import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'conditionValueError',
})

//this pipe returns errors one by one in condition values
export class ConditionValueErrorPipe implements PipeTransform {
    transform(errorMsg:string[],conditionGroupError:any):any {
        const errobj = {...conditionGroupError};
        return errorMsg[Object.keys(errobj)[0]];
    }
}